// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://soneium.blockscout.com/address/0xEEDE303b8602Db7556eD57BDf7133A6bAADa294D
export const pufETH__ETH = '0xEEDE303b8602Db7556eD57BDf7133A6bAADa294D';

// https://soneium.blockscout.com/address/0x884E2819193d8c8993036290D5a8778Dbe3942f2
export const BTC__USD = '0x884E2819193d8c8993036290D5a8778Dbe3942f2';

// https://soneium.blockscout.com/address/0x564eC0aeEb910e99dA4aC9341f3C01052F80A74B
export const SolvBTCBBN__SolvBTC_Exchange_Rate = '0x564eC0aeEb910e99dA4aC9341f3C01052F80A74B';

// https://soneium.blockscout.com/address/0xaDE1b9AbB98c6A542E4B49db2588a3Ec4bF7Cdf0
export const L2_Sequencer_Uptime_Status_Feed = '0xaDE1b9AbB98c6A542E4B49db2588a3Ec4bF7Cdf0';

// https://soneium.blockscout.com/address/0x97D2996B726F774B7c5BF77C7A74CFe98174a9d3
export const solvBTC__BTC = '0x97D2996B726F774B7c5BF77C7A74CFe98174a9d3';

// https://soneium.blockscout.com/address/0x251Ef178518aba5aa1df24713344EA1C6d9ccc67
export const USD1__USD = '0x251Ef178518aba5aa1df24713344EA1C6d9ccc67';

// https://soneium.blockscout.com/address/0x6D414dC3F9D8822D947B737CA8F75b1c4d6C8542
export const LINK__ETH = '0x6D414dC3F9D8822D947B737CA8F75b1c4d6C8542';

// https://soneium.blockscout.com/address/0x75196350e8F9Ffa8e6a917E3C6E073D24F458781
export const WBTC__USD = '0x75196350e8F9Ffa8e6a917E3C6E073D24F458781';

// https://soneium.blockscout.com/address/0x2580FA33f9dfD9D26F1aC418E09113f3E9c316c2
export const Calculated_wstASTR__USD = '0x2580FA33f9dfD9D26F1aC418E09113f3E9c316c2';

// https://soneium.blockscout.com/address/0x316DefA0f4BA9567aF55E66212e66b4fD6646eEE
export const USR__USD = '0x316DefA0f4BA9567aF55E66212e66b4fD6646eEE';

// https://soneium.blockscout.com/address/0x877654fE4da2FC54453a212aac601247b2A1B786
export const USR_USD_Exchange_Rate = '0x877654fE4da2FC54453a212aac601247b2A1B786';

// https://soneium.blockscout.com/address/0xF049354158e13F6794A3cCD236694E0e1BD9AF79
export const OUSDT__USD = '0xF049354158e13F6794A3cCD236694E0e1BD9AF79';

// https://soneium.blockscout.com/address/0x4516fDa3259110EefAfC6fBcE266417B3F3b985a
export const wstETH__ETH = '0x4516fDa3259110EefAfC6fBcE266417B3F3b985a';

// https://soneium.blockscout.com/address/0x1A26E1197F86E8938FdFa11bA1597dE8e211a8B0
export const AAVE_Network_Emergency_Count_Soneium = '0x1A26E1197F86E8938FdFa11bA1597dE8e211a8B0';

// https://soneium.blockscout.com/address/0x4f80347FE3579859232e1e8E0735020C008408cB
export const RLP_USD_Exchange_Rate = '0x4f80347FE3579859232e1e8E0735020C008408cB';

// https://soneium.blockscout.com/address/0xE92d289831823c96C22592952C1cfA2584a65038
export const USDT__USD = '0xE92d289831823c96C22592952C1cfA2584a65038';

// https://soneium.blockscout.com/address/0x291cF980BA12505D65ee01BDe0882F1d5e533525
export const ETH__USD = '0x291cF980BA12505D65ee01BDe0882F1d5e533525';

// https://soneium.blockscout.com/address/0x46522a7fD5bD5E7aaFF862C17E116152e07d7158
export const USDC__USD = '0x46522a7fD5bD5E7aaFF862C17E116152e07d7158';

// https://soneium.blockscout.com/address/0x5f01955B7048d1aC6F8023A5508963617f9FE4f8
export const LINK__USD = '0x5f01955B7048d1aC6F8023A5508963617f9FE4f8';

// https://soneium.blockscout.com/address/0xBa5C28f78eFdC03C37e2C46880314386aFf43228
export const ASTR__USD = '0xBa5C28f78eFdC03C37e2C46880314386aFf43228';

// https://soneium.blockscout.com/address/0xD5046A1128a57BDc609332A41Cfda72dAd623BC5
export const wstUSR__stUSR_Exchange_Rate = '0xD5046A1128a57BDc609332A41Cfda72dAd623BC5';

// https://soneium.blockscout.com/address/0x931602D8758E7A891Dce57A31c2A23A98931Fe1c
export const stETH__ETH = '0x931602D8758E7A891Dce57A31c2A23A98931Fe1c';

// https://soneium.blockscout.com/address/0x42237D7d96A4178bB22498bb3B2C689D502DE847
export const xSolvBTC_NAV = '0x42237D7d96A4178bB22498bb3B2C689D502DE847';

export const CHAIN_ID = 1868;
